export const sawEstateTtl = 1000 * 60 * 30; // 30 minutes
